/** Return false - For No Errors
 *  Return Error Message - For NEXT/UPDATE button disabled
 */
import React from 'react';
import { ErrorMsgWrap } from './styles';

export function validation(key, value, allData) {
	let trimmedInput = value.trim();
	switch (key) {
		case 'granteeOrgCntFirstName':
			return nameValidation(trimmedInput, 'First Name');
		case 'granteeOrgCntLastName':
			return nameValidation(trimmedInput, 'Last Name');
		case 'granteeOrgCntPhoneNumber':
			return phoneValidation(trimmedInput, allData);
		case 'granteeOrgCntEmailAddr':
			return emailValidation(trimmedInput, allData);
		case 'additionalComments':
			return fieldBlankChecking(trimmedInput);
		case 'notifyFirstName':
			return notifyFirstNameValidation(trimmedInput, allData);
		case 'notifyLastName':
			return notifyLastNameValidation(trimmedInput, allData);
		case 'amountAllocation':
			return amountFieldChecking(trimmedInput, 'Please enter grant agreement amount to continue');
		default:
			return false;
	}
}

function amountFieldChecking(input, text) {
	if (input === '') {
		return <ErrorMsgWrap>{text}</ErrorMsgWrap>;
	}
}

function fieldBlankChecking(input) {
	if (!input || input === '') {
		return <ErrorMsgWrap>Please specify additional comments to continue</ErrorMsgWrap>;
	}
}

function nameValidation(input, type) {
	if (input === '') {
		return <ErrorMsgWrap>Please specify {type} to continue</ErrorMsgWrap>;
	}
	if (type === 'Last Name') {
		if (input.length < 2) {
			return <ErrorMsgWrap>{type} is too short. Please correct to proceed</ErrorMsgWrap>;
		}
	}
}

function notifyFirstNameValidation(input, allData) {
	if (!allData.notifyFirstName || allData.notifyFirstName === '')
		if (input === '') return <ErrorMsgWrap>Please input first name!</ErrorMsgWrap>;
}

function notifyLastNameValidation(input, allData) {
	if (!allData.notifyLastName || allData.notifyLastName === '')
		if (input === '') return <ErrorMsgWrap>Please input last name!</ErrorMsgWrap>;
}
 
function phoneValidation(input, allData) {
	if (!allData.granteeOrgCntEmailAddr || allData.granteeOrgCntEmailAddr === '') {
		let trimmedInput = input;
		if (trimmedInput === '') {
			return <ErrorMsgWrap>Please input your phone number!</ErrorMsgWrap>;
		}
		let reg = /^[0-9+()-]{0,25}$/;
		if (!reg.test(trimmedInput)) {
			return <ErrorMsgWrap>Invalid Phone Number</ErrorMsgWrap>;
		}
	}
}

function emailValidation(input, allData) {
	if (!allData.granteeOrgCntPhoneNumber || allData.granteeOrgCntPhoneNumber === '') {
		if (input === '') {
			return <ErrorMsgWrap>Please input your email address!</ErrorMsgWrap>;
		}
		let emailRegEx = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
		if (!emailRegEx.test(String(input).toLowerCase())) {
			return <ErrorMsgWrap>Email Address is in an invalid format. Please correct to continue</ErrorMsgWrap>;
		}
	}
}